import styled from "styled-components";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100vh;
  background-color: #f6f7f7;
`;

const PageContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 1em 2em;
  background-color:#ffffff;
`;

export { AppContainer, PageContainer };
